import React, { useEffect, useState } from 'react';
import { AltFieldItem } from 'views/AltFieldMapper.js';

const EmailEditor = ({ onChange, style, utils, value }) => {

    const [body, setBody] = useState(null);
    const [subject, setSubject] = useState(null);

    const onBodyChange = text => {

        // update local state with new subject value
        setBody(text);

        // notify subscribers of data change
        if(typeof(onChange) === 'function') {
            onChange({ body: text, subject });
        }
    }

    const onSubjectChange = text => {

        // update local state with new subject value
        setSubject(text);

        // notify subscribers of data change
        if(typeof(onChange) === 'function') {
            onChange({ body, subject: text });
        }
    }

    useEffect(() => {
        setBody(value?.body);
        setSubject(value?.subject);
    }, [value]);
    
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            ...style
        }}>
            <AltFieldItem
            item={{
                component: 'textfield',
                onChange: onSubjectChange,
                title: 'Email Subject',
                value: subject
            }} 
            lastItem={false}
            utils={utils} />
            <AltFieldItem
            item={{
                component: 'textview',
                onChange: onBodyChange,
                title: 'Email Content',
                value: body
            }} 
            utils={utils} />
        </div>
    )
}

export default EmailEditor;
